import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import auth from '@/helpers/auth';

export function useLogout() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => {
            return axios.post('/api/auth/logout');
        },
        onSuccess: () => {
            auth.clearSession();
            queryClient.clear();
        },
    });
}
